import styled from "styled-components";
import { Input } from "antd";

// IMAGES
import AuthTopShape from "Assets/Images/AuthImages/auth_top.svg";
import AuthBottomShape from "Assets/Images/AuthImages/auth_bottom.svg";

// Shared with the Teacher Portal (Website) auth screens.
const AUTH_FONT = `"Outfit", sans-serif`;

export const ParentWrapper = styled.div`
	min-height: 100vh;
	width: 100%;
	display: flex;
	background-color: #fff;
	font-family: ${AUTH_FONT};

	*,
	*:before,
	*:after {
		box-sizing: border-box;
	}

	.auth-wrap-left,
	.auth_wrap_right {
		width: 50%;
		display: flex;
		flex-direction: column;
		padding: 50px;
	}

	/* ---------------- LEFT COLUMN ---------------- */
	.auth-wrap-left {
		background-color: #fff9eb;
		position: relative;
		overflow: hidden;

		&:before {
			position: absolute;
			content: "";
			right: 0;
			top: 0;
			height: 100%;
			width: 100%;
			background-position: top right;
			background-size: 280px;
			background-repeat: no-repeat;
			background-image: url(${AuthTopShape});
		}

		&:after {
			position: absolute;
			content: "";
			left: 0;
			bottom: 0;
			height: 100%;
			width: 100%;
			background-position: bottom left;
			background-size: 336px;
			background-repeat: no-repeat;
			background-image: url(${AuthBottomShape});
		}
	}

	.auth_wrap_logo {
		flex: 0 0 auto;
		position: relative;
		z-index: 1;

		.auth_logo {
			width: 245px;
			max-width: 100%;
			height: auto;
			display: block;
		}
	}

	.auth_wrap_left_in {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		text-align: left;
		position: relative;
		z-index: 1;
		max-width: 540px;

		h1 {
			font-family: ${AUTH_FONT};
			font-size: 70px;
			font-weight: 600;
			line-height: 1.071em;
			color: #021e40;
			margin: 0 0 20px;
		}

		p {
			font-family: ${AUTH_FONT};
			font-size: 18px;
			font-weight: 300;
			line-height: 1.3em;
			color: #021e40;
			margin: 0;
		}
	}

	.redfont {
		color: #ee2d2f;
	}

	/* ---------------- RIGHT COLUMN ---------------- */
	.auth_wrap_right {
		background: #ffffff;
		padding: 50px 100px;
	}

	.auth_right_inner {
		flex: 1 1;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		text-align: left;
		padding: 50px 0;
	}

	.auth_right_head {
		margin-bottom: 30px;

		h2 {
			font-family: ${AUTH_FONT};
			font-size: 54px;
			font-weight: 600;
			line-height: 1.111em;
			color: #021e40;
			margin: 0 0 10px;
		}

		h4 {
			font-family: ${AUTH_FONT};
			font-size: 29px;
			font-weight: 500;
			line-height: 1em;
			color: #ee2d2f;
			margin: 0 0 20px;
		}
	}

	form {
		width: 100%;
	}

	.field_wrapper {
		display: flex;
		flex-direction: column;
		margin-bottom: 4px;
	}

	.text {
		font-family: ${AUTH_FONT};
		font-size: 16px;
		font-weight: 300;
		line-height: 100%;
		text-transform: capitalize;
		color: #333333;
		margin: 0 0 12px;
	}

	.forgot-password-parent {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 20px;

		.forgot-password {
			font-family: ${AUTH_FONT};
			font-size: 16px;
			font-weight: 300;
			color: #197f9f;
			text-decoration: underline;
			cursor: pointer;

			&:hover {
				color: #ee2d2f;
			}
		}
	}

	.login_btn_divs {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.login-button-parent {
		display: flex;
		align-items: center;
		gap: 15px;
		margin-right: 10px;
	}

	/* ---------------- BUTTONS ---------------- */
	.customs_btn {
		color: #fff;
		font-family: ${AUTH_FONT};
		font-size: 18px;
		font-weight: 400;
		line-height: normal;
		height: auto;
		padding: 5px 20px;
		padding-right: 5px;
		background: #ee2d2f;
		border: 0;
		border-radius: 500px;
		text-decoration: unset;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		box-shadow: none;
		transition:
			background-color 0.3s ease,
			padding 0.3s ease;

		&:hover,
		&:focus {
			color: #fff;
			background: #e86387;
			border: 0;
			padding: 5px 26px;
			padding-right: 5px;
		}

		&:hover .btn_arrow_wrap {
			transition: 0.3s ease;
			transform: rotate(45deg);
			top: -2px;
			position: relative;
		}

		.btn_arrow_wrap {
			line-height: 1;
			padding-left: 8px;
			display: flex;
			align-items: center;

			img {
				width: 34px;
				height: auto;
			}
		}

		&.ghost_btn {
			background: transparent;
			color: #ee2d2f;
			border: 1px solid #ee2d2f;
			padding: 5px 24px;

			&:hover,
			&:focus {
				background: #ee2d2f;
				color: #fff;
				border: 1px solid #ee2d2f;
				padding: 5px 24px;
			}
		}

		&.ant-btn-loading {
			opacity: 0.85;
		}
	}

	/* ---------------- ANTD FORM OVERRIDES ---------------- */
	.ant-form-item {
		margin-bottom: 20px;
	}

	.ant-form-item-explain,
	.ant-form-item-explain div {
		font-family: ${AUTH_FONT};
		font-size: 14px;
		font-weight: 300;
		color: #a90e0e;
		margin-top: 8px;
	}

	.ant-form-item-has-error .login,
	.ant-form-item-has-error .login:hover,
	.ant-form-item-has-error .login:focus,
	.ant-form-item-has-error .login .ant-input,
	.ant-form-item-has-error .ant-input-affix-wrapper.login {
		border-color: #a90e0e;
		background-color: #f7f7f7;
		box-shadow: none;
	}

	/* ---------------- RESPONSIVE ---------------- */
	@media screen and (max-width: 1450px) {
		.auth_wrap_left_in h1 {
			font-size: 58px;
		}

		.auth_right_head h2 {
			font-size: 44px;
		}
	}

	@media screen and (max-width: 1320px) {
		.auth-wrap-left,
		.auth_wrap_right {
			padding: 50px;
		}
	}

	@media screen and (max-width: 1199px) {
		.auth_wrap_right {
			padding: 50px;
		}

		.auth_wrap_left_in h1 {
			font-size: 52px;
		}

		.auth_right_head h2 {
			font-size: 40px;
		}
	}

	@media screen and (max-width: 991px) {
		flex-direction: column;
		min-height: 100%;

		.auth-wrap-left,
		.auth_wrap_right {
			width: 100%;
			padding: 20px;
		}

		.auth-wrap-left:before {
			background-size: 250px;
		}

		.auth-wrap-left:after {
			background-size: 310px;
		}

		.auth_wrap_left_in {
			padding-top: 50px;
		}

		.auth_right_inner {
			padding: 30px 0;
		}
	}

	@media screen and (max-width: 767px) {
		.auth-wrap-left:before {
			background-size: 200px;
		}

		.auth-wrap-left:after {
			background-size: 280px;
		}

		.auth_right_head {
			margin-bottom: 10px;
		}

		.auth_wrap_left_in h1 {
			font-size: 45px;
		}

		.auth_right_head h2 {
			font-size: 38px;
		}

		.auth_right_head h4 {
			font-size: 22px;
		}
	}

	@media screen and (max-width: 450px) {
		.auth_wrap_left_in h1 {
			font-size: 40px;
		}

		.auth_right_head h2 {
			font-size: 32px;
		}

		.login_btn_divs {
			flex-wrap: wrap;
			gap: 15px;
		}
	}
`;

const inputStyles = `
	min-height: 47px;
	width: 100%;
	padding: 10px 20px;
	border: 1px solid #e9e9e9;
	border-radius: 10px;
	background-color: #f7f7f7;
	font-family: ${AUTH_FONT};
	font-size: 16px;
	font-weight: 300;
	color: #021e40;
	box-shadow: none;

	&:hover,
	&:focus,
	&.ant-input-affix-wrapper-focused {
		border-color: #e9e9e9;
		box-shadow: none;
	}

	input::placeholder,
	&::placeholder {
		font-family: ${AUTH_FONT};
		font-weight: 300;
		font-size: 15px;
		color: rgba(2, 30, 64, 0.45);
	}

	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active {
		transition: background-color 5000s ease-in-out 0s;
		-webkit-text-fill-color: #021e40 !important;
	}
`;

export const InputWrapper = styled(Input)`
	${inputStyles}
`;

export const PasswordWrapper = styled(Input.Password)`
	${inputStyles}

	.ant-input {
		background-color: transparent;
		border: 0;
		padding: 0;
		font-family: ${AUTH_FONT};
		font-size: 16px;
		font-weight: 300;
		color: #021e40;
		box-shadow: none;
	}

	.ant-input-suffix svg {
		color: rgba(2, 30, 64, 0.6);
	}
`;
